import styles from "./PageSeo.module.scss";
import { Card, Divider, Form, Input, Radio, Typography } from "antd";
import FileUpload from "components/FileUpload";
import PageTitle from "components/PageTitle";
import { PageType, SeoDto } from "dtos/seo.dto";
import DashboardLayout from "layout/DashboardLayout";

function PageSeo() {
  return (
    <DashboardLayout>
      <div className="flex m-6">
        <Card className="m-auto" style={{ width: 600, maxWidth: "100%" }}>
          <PageTitle title="Users" pageTitle={[{ title: "Page SEO" }]} />
          <Form layout="vertical">
            <Typography.Title level={4}>General</Typography.Title>
            <Typography.Text type="secondary" className="mb-4 block">
              Top level general SEO tags
            </Typography.Text>
            <Form.Item<SeoDto> name={"title"} label="Title">
              <Input />
            </Form.Item>
            <Form.Item<SeoDto> name={"description"} label="Description">
              <Input.TextArea autoSize={{ minRows: 4 }} />
            </Form.Item>
            <Form.Item<SeoDto> name={"keywords"} label="Keywords">
              <Input.TextArea autoSize={{ minRows: 1 }} />
            </Form.Item>

            <Divider />
            <Typography.Title level={4}>Open Graph</Typography.Title>
            <Typography.Text type="secondary" className="mb-4 block">
              For Facebook, WhatsApp og SEO
            </Typography.Text>
            <Form.Item<SeoDto> name={["og", "type"]} label="Title">
              <Radio.Group>
                <Radio value={PageType.WEBSITE}>Website</Radio>
                <Radio value={PageType.ARTICLE}>Article</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item<SeoDto> name={["og", "title"]} label="Title">
              <Input />
            </Form.Item>
            <Form.Item<SeoDto> name={["og", "description"]} label="Description">
              <Input.TextArea autoSize={{ minRows: 4 }} />
            </Form.Item>
            <Form.Item<SeoDto> name={["og", "image"]} label="Image">
              <FileUpload fileType="image" />
            </Form.Item>
          </Form>
        </Card>
      </div>
    </DashboardLayout>
  );
}

export default PageSeo;
